import StatusModal from './StatusModal';

export default StatusModal;
